<ion-list mode="ios" lines="none" class="list-content">
  <!-- ? Titulo y cerrar -->
  <ion-item
    mode="md"
    lines="none"
    color="white"
    class="item-header separator-gray"
  >
    <ion-label
      mode="md"
      lines="none"
      color="status-icon-enable"
      class="have-added-your-cart"
    >
      {{ 'Labels.have-added-your-cart' | translate }}
    </ion-label>

    <ion-button
      class="mpe-button-icon-circle ion-no-padding button-close"
      size="default"
      mode="ios"
      shape="round"
      color="status-icon-enable"
      fill="clear"
      slot="end"
      (click)="onClose()"
    >
      <ion-icon
        slot="icon-only"
        color="status-icon-enable"
        name="close"
      ></ion-icon>
    </ion-button>
  </ion-item>

  <!-- ? Detalle del producto/promo agregado -->
  <ng-container *ngFor="let cart of addCart | slice: 0:3; let i=index">
    <ion-item
      mode="md"
      lines="none"
      color="white"
      class="item-content"
      [ngClass]="{
        suggested: cart['modelo'] === 0,
        gamification: cart['modelo'] === 1,
        keyaccounts: cart['modelo'] === 4,
        'separator-gray-dashed': addCart.length > 1
      }"
    >
      <ion-img
        slot="start"
        class="imagen"
        [src]="cart['imagen'] || cart['imagen_url']"
      ></ion-img>

      <ion-label mode="md" color="status-icon-enable" class="title">
        <ion-label
          mode="md"
          color="status-icon-enable"
          class="title mpe-font-weight-600"
        >
          {{ cart['title'] || cart['Promocion'] }}
          <!-- * Info de productos -->
          <ng-container *ngIf="cart['subtitle']">
            <p class="content" id="subtitle">
              <ion-text mode="md" color="cadet-grey">
                {{ cart['subtitle'] }}
              </ion-text>
            </p>
            <p class="content">
              {{ cart['productos'] }}&nbsp;{{ "Labels.boxes" | translate |
              lowercase }}
              <ion-text
                color="tpcta"
                class="ion-float-right title mpe-font-weight-600"
              >
                {{ (cart['precio'] * cart['productos']) | currency }}
              </ion-text>
            </p>
          </ng-container>
        </ion-label>

        <!-- * Info de promos -->
        <ng-container *ngIf="cart['Promocion']">
          <p class="content-promo">
            <ion-label
              mode="md"
              color="status-icon-enable"
              class="list-products title"
            >
              <ng-container *ngFor="let product of cart['Productos']">
                <p class="products">
                  {{ product.productos }}&nbsp;{{ product.title }}
                </p>
              </ng-container>
            </ion-label>

            <ion-label mode="md" color="status-icon-enable" class="title">
              <p
                class="ion-text-end total_precio_descuento mpe-font-weight-600"
              >
                {{ (cart['Productos'] | summaryPrice : 1).total_precio_descuento
                | currency }}
              </p>
              <p class="ion-text-end total_precio">
                <del>
                  {{ (cart['Productos'] | summaryPrice : 1).total_precio |
                  currency }}
                </del>
              </p>
              <p class="ion-text-end total_descuento">
                {{ (cart['Productos'] | summaryPrice : 1).total_descuento |
                currency }}
              </p>
            </ion-label>
          </p>
        </ng-container>
      </ion-label>
    </ion-item>
  </ng-container>

  <ng-container *ngIf="addCart.length > 3">
    <ion-item
      mode="md"
      lines="none"
      color="white"
      class="ion-text-center item-more-products separator-gray-dashed"
    >
      <ion-label mode="md" color="cadet-grey" class="more-products">
        {{ 'Labels.and-more-products' | translate: { more: (addCart.length - 3)
        } }}
      </ion-label>
    </ion-item>
  </ng-container>

  <!-- ? Precio total en Carrito -->
  <ion-item mode="md" lines="none" class="item-cart">
    <ion-label
      mode="md"
      color="cadet-grey"
      class="mpe-font-weight-600 total-cart ion-text-end"
      [attr.data-test]="'Automation.txt-summary-order-total-text' | translate"
    >
      <ion-text mode="md"> {{ 'Labels.total-cases' | translate }}: </ion-text>
      <br />
      <ion-text mode="md"> {{ 'Labels.total-amount' | translate }}: </ion-text>
      <ng-container *ngIf="summaryPriceCart.precio_descuento < 0">
        <br />
        <ion-text mode="md"> {{ 'Labels.discount' | translate }}: </ion-text>
      </ng-container>
    </ion-label>

    <ion-label
      mode="md"
      color="status-icon-enable"
      class="mpe-font-weight-600 ion-text-end prices-cart"
    >
      <ion-text
        mode="md"
        [attr.data-test]="'Automation.txt-summary-order-total-boxes' | translate"
      >
        {{ summaryPriceCart.total_cajas }}
      </ion-text>
      <br />
      <ion-text
        mode="md"
        color="tpcta"
        [attr.data-test]="'Automation.txt-summary-order-total-amount' | translate"
      >
        {{ summaryPriceCart.total_precio | currency }}
      </ion-text>
      <ng-container *ngIf="summaryPriceCart.precio_descuento < 0">
        <br />
        <ion-text
          mode="md"
          color="danger"
          [attr.data-test]="'Automation.txt-summary-order-total-discount' | translate"
        >
          {{ summaryPriceCart.precio_descuento | currency }}
        </ion-text>
      </ng-container>
    </ion-label>
  </ion-item>
</ion-list>
